import icons from "@/assets/icons";
import React, { useState, useEffect, useRef, useId } from "react";
interface VoiceRecorderProps {
  onSave: (audioBlob: any) => void;
  inputVoice?: string;
}

const VoiceRecorder: React.FC<VoiceRecorderProps> = ({
  onSave,
  inputVoice,
}) => {
  const [recording, setRecording] = useState<boolean>(false);
  const [audioUrl, setAudioUrl] = useState<string>("");
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const audioChunks = useRef<Blob[]>([]);
  const audioRef = useRef<HTMLAudioElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  useEffect(() => {
    setAudioUrl(inputVoice);
    setRecording(false);
    setIsPlaying(false);
  }, [inputVoice]);
  useEffect(() => {
    if (recording) {
      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then((stream) => {
          mediaRecorderRef.current = new MediaRecorder(stream);
          mediaRecorderRef.current.ondataavailable = (event: BlobEvent) => {
            audioChunks.current.push(event.data);
          };
          mediaRecorderRef.current.onstop = () => {
            const audioBlob = new Blob(audioChunks.current, {
              type: "audio/wav",
            });
            const url = URL.createObjectURL(audioBlob);
            setAudioUrl(url);

            const audioFile = new File(audioChunks.current, "recording.mp3", {
              type: "audio/mp3",
              lastModified: Date.now(),
            });

            onSave(audioFile);
            // onSave(audioChunks.current); // Call the onSave callback with the audioBlob
            // if (waveSurfer.current) {
            //   waveSurfer.current.load(url);
            // }

            audioChunks.current = [];
          };
          mediaRecorderRef.current.start();
        })
        .catch((error) => {
          console.error("Error accessing microphone: ", error);
          setRecording(false);
        });
    } else {
      if (
        mediaRecorderRef.current &&
        mediaRecorderRef.current.state === "recording"
      ) {
        mediaRecorderRef.current.stop();
      }
    }
  }, [recording, onSave]);
  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play().catch((error) => {
          console.error("Error playing audio:", error);
        });
      }
      setIsPlaying(!isPlaying);
    }
  };
  const handleRecordButtonClick = () => {
    setRecording(!recording);
  };

  const handleDiscardButtonClick = () => {
    setAudioUrl("");
    onSave(undefined);
    // if (waveSurfer.current) {
    //   waveSurfer.current.empty();
    // }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setAudioUrl(url);
      // Optionally, you can save the file directly to the backend
      onSave(file);
      //   if (waveSurfer.current) {
      //     waveSurfer.current.load(url);
      //   }
    }
  };
  var uniqueId = useId();
  return (
    <div
      className="flex  gap-2 flex-col bg-bg-cards3 rounded-xl p-2"
      id={"parentdiv-" + uniqueId}
    >
      <button
        id={"recorde-button" + uniqueId}
        onClick={handleRecordButtonClick}
        className="flex items-center justify-center"
      >
        <div className="w-6 h-6">
          {recording ? icons.stoprecording : icons.startrecord}
        </div>
      </button>
      <label
        htmlFor={uniqueId}
        className="inline-flex flex-col items-center gap-3 text-text-caption2 text-[10px] justify-center"
      >
        <div className="flex items-center justify-center w-6 h-6">
          {icons.uploadvoice}
        </div>
      </label>{" "}
      {/* <input
        type="file"
        accept="audio/*"
        onChange={handleFileChange}
        style={{ marginTop: "10px", display: "block" }}
      /> */}
      <input
        type="file"
        accept="audio/*"
        id={uniqueId}
        onChange={handleFileChange}
        style={{ display: "none" }}
      />
      {audioUrl && (
        <div
          className="flex justify-center items-center"
          id={"div-" + uniqueId}
        >
          <button
            id={"button-" + uniqueId}
            onClick={togglePlay}
            style={{ background: "none", border: "none", cursor: "pointer" }}
          >
            {" "}
            {isPlaying ? icons.pause : icons.playsound}{" "}
          </button>{" "}
          <audio
            id={"audio-" + uniqueId}
            ref={audioRef}
            src={audioUrl}
            style={{ display: "none" }}
          ></audio>
          {/* <audio controls src={audioUrl} className="rounded-xl "></audio> */}
        </div>
      )}{" "}
      {audioUrl && (
        <button
          onClick={handleDiscardButtonClick}
          className="flex items-center justify-center"
        >
          {" "}
          <div className=" w-6 h-6">{icons.trash}</div>
        </button>
      )}
    </div>
  );
};

export default VoiceRecorder;
